import { ChartOfAccount } from "./chart-of-account";
import { GeneralLedger } from "./general-ledger";
import { SystemField } from "./system-field";

export class JournalEntryDetail extends SystemField{
    
    coa_id?:string;/// chart of account id
    sub_coa_id?:string;
    credit_amount?:number;
    debit_amount?:number;
    transaction_type?:string;
    ref_number?:string;
    comments?:string;
    general_ledger_id?:string;

    //relationship
    chart_of_account?:ChartOfAccount;
    general_ledger?:GeneralLedger;
}
